import { render, staticRenderFns } from "./SearchTop.vue?vue&type=template&id=4be54cbb&scoped=true"
import script from "./SearchTop.vue?vue&type=script&lang=js"
export * from "./SearchTop.vue?vue&type=script&lang=js"
import style0 from "./SearchTop.vue?vue&type=style&index=0&id=4be54cbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be54cbb",
  null
  
)

export default component.exports